import { ChevronDown, ChevronUp } from '@remarkable/ark-icons';
import { clsx } from 'clsx';
import { useState } from 'react';

export function ExpandableNotification({
  className,
  title,
  level,
  children,
  ...props
}: {
  level: 'success' | 'error' | 'warning' | 'info';
} & React.HTMLAttributes<HTMLDivElement>) {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div {...props} className={clsx('bg-paper-3', className)}>
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="flex w-full items-center justify-between gap-8 p-8"
      >
        <div className="flex items-center gap-8">
          <div
            className={clsx('inline-block size-12 rounded-full', {
              'bg-feedback-green-500': level === 'success',
              'bg-feedback-red-500': level === 'error',
              'bg-feedback-orange-500': level === 'warning',
              'border border-paper-8 bg-paper-2': level === 'info',
            })}
          />
          {title}
        </div>
        <div>{isExpanded ? <ChevronUp /> : <ChevronDown />}</div>
      </button>
      {isExpanded && <div className="p-8">{children}</div>}
    </div>
  );
}
